<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <router-link to="/market"
          >{{ pair.split("_")[0] }}/{{ pair.split("_")[1] }}
          <i class="fad fa-chevron-down"></i>
        </router-link>

        <div class="left" v-on:click="desktopmode()">
          <router-link v-bind:to="'/advanced/' + pair"
            ><i class="fad fa-desktop"></i> {{ $t("Desktop") }}</router-link
          >
        </div>
        <div class="right" v-if="getToken">
          <router-link to="/orderhistory">{{ $t("OrderHistory") }}</router-link>
        </div>
      </div>
    </div>

    <div class="topmarket">
      <div class="container-center lg">
        <div class="tophead text-center">
          <div class="col-xs-3 active" v-if="type == 'BUY'">
            <p class="pointer">{{ $t("Buy") }}</p>
          </div>
          <div class="col-xs-3" v-else v-on:click="type = 'BUY'">
            <p class="pointer">{{ $t("Buy") }}</p>
          </div>
          <div class="col-xs-3 active" v-if="type == 'SELL'">
            <p class="pointer">{{ $t("Sell") }}</p>
          </div>
          <div class="col-xs-3" v-else v-on:click="type = 'SELL'">
            <p class="pointer">{{ $t("Sell") }}</p>
          </div>
          <div class="col-xs-6">
            <router-link v-bind:to="'/chart/' + pair">
              <p class="pointer">
                <i class="fad fa-chart-bar"></i> {{ $t("Chart") }}
              </p>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="row">
        <div class="col-xs-6">
          <form
            @submit.prevent="submitBuy"
            class="form-horizontal"
            v-if="type == 'BUY'"
          >
            <div class="row">
              <div class="form-group">
                <label for="rate" class="col-xs-12"
                  ><small
                    >{{ $t("Price") }}({{ pair.split("_")[0] }})</small
                  ></label
                >
                <div class="col-xs-12">
                  <div class="input-group">
                    <span
                      class="input-group-addon font-bold c-white pointer"
                      v-on:click="minusPrice()"
                      ><i class="fad fa-minus-square"></i
                    ></span>
                    <input
                      id="rate"
                      type="text"
                      v-model="rate"
                      v-on:input="setAmount"
                      class="form-control center-block"
                    />
                    <span
                      class="input-group-addon font-bold c-white pointer"
                      v-on:click="plusPrice()"
                    >
                      <i class="fad fa-plus-square"></i
                    ></span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="volume" class="col-xs-12"
                  ><small
                    >{{ $t("Amount") }}({{ pair.split("_")[1] }})</small
                  ></label
                >
                <div class="col-xs-12">
                  <div class="input-group">
                    <span
                      class="input-group-addon font-bold c-white pointer"
                      v-on:click="minusVolume()"
                      ><i class="fad fa-minus-square"></i
                    ></span>
                    <input
                      id="volume"
                      v-model="volume"
                      v-on:input="setAmount"
                      class="form-control"
                      type="number"
                      min="0"
                      step="0.00000001"
                    />
                    <span
                      class="input-group-addon font-bold c-white pointer"
                      v-on:click="plusVolume()"
                    >
                      <i class="fad fa-plus-square"></i
                    ></span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12">
                  <div class="percent" v-on:click="setBuy(0.25)">
                    <div class="btnp">
                      <span href="#">25%</span>
                    </div>
                  </div>
                  <div class="percent" v-on:click="setBuy(0.5)">
                    <div class="btnp">
                      <span href="#">50%</span>
                    </div>
                  </div>
                  <div class="percent" v-on:click="setBuy(0.75)">
                    <div class="btnp">
                      <span href="#">75%</span>
                    </div>
                  </div>
                  <div class="percent" v-on:click="setBuy(1)">
                    <div class="btnp">
                      <span href="#">100%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="amount" class="col-xs-12"
                  ><small
                    >{{ $t("Total") }}({{ pair.split("_")[0] }})</small
                  ></label
                >
                <div class="col-xs-12">
                  <input
                    id="amount"
                    v-model="amount"
                    v-on:input="setVolume"
                    class="form-control"
                    type="number"
                    min="0"
                    step="0.00000001"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12 text-right">
                  <i class="fad fa-wallet m-r-xs"></i>
                  <span class="font-bold c-white" v-if="getToken"
                    >{{ fixed(getBalance[pair.split("_")[0]].available) }}
                    {{ pair.split("_")[0] }}</span
                  >
                  <span class="font-bold c-white" v-else
                    >-- {{ pair.split("_")[0] }}</span
                  >
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12">
                  <button
                    v-if="loading"
                    class="btn btn-default btn-block"
                    disabled=" "
                  >
                    <i class="fad fa-spinner-third fa-spin m-r-xs"></i
                    >{{ $t("Loading") }}
                  </button>
                  <button
                    v-else-if="!rate || !amount || !volume"
                    class="btn btn-default btn-block"
                    disabled=" "
                  >
                    {{ $t("Buy") }} {{ pair.split("_")[1] }}
                  </button>
                  <button v-else class="btn btn-buy btn-block c-white">
                    {{ $t("Buy") }} {{ pair.split("_")[1] }}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <form
            @submit.prevent="submitSell"
            class="form-horizontal"
            v-if="type == 'SELL'"
          >
            <div class="row">
              <div class="form-group">
                <label for="rate" class="col-xs-12"
                  ><small
                    >{{ $t("Price") }}({{ pair.split("_")[0] }})</small
                  ></label
                >
                <div class="col-xs-12">
                  <div class="input-group">
                    <span
                      class="input-group-addon font-bold c-white pointer"
                      v-on:click="minusPrice()"
                      ><i class="fad fa-minus-square"></i
                    ></span>
                    <input
                      id="rate"
                      type="text"
                      v-model="rate"
                      v-on:input="setAmount"
                      class="form-control center-block"
                    />
                    <span
                      class="input-group-addon font-bold c-white pointer"
                      v-on:click="plusPrice()"
                    >
                      <i class="fad fa-plus-square"></i
                    ></span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="volume" class="col-xs-12"
                  ><small
                    >{{ $t("Amount") }}({{ pair.split("_")[1] }})</small
                  ></label
                >
                <div class="col-xs-12">
                  <div class="input-group">
                    <span
                      class="input-group-addon font-bold c-white pointer"
                      v-on:click="minusVolume()"
                      ><i class="fad fa-minus-square"></i
                    ></span>
                    <input
                      id="volume"
                      v-model="volume"
                      v-on:input="setAmount"
                      class="form-control"
                      type="number"
                      min="0"
                      step="0.00000001"
                    />
                    <span
                      class="input-group-addon font-bold c-white pointer"
                      v-on:click="plusVolume()"
                    >
                      <i class="fad fa-plus-square"></i
                    ></span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12">
                  <div class="percent" v-on:click="setSell(0.25)">
                    <div class="btnp">
                      <span href="#">25%</span>
                    </div>
                  </div>
                  <div class="percent" v-on:click="setSell(0.5)">
                    <div class="btnp">
                      <span href="#">50%</span>
                    </div>
                  </div>
                  <div class="percent" v-on:click="setSell(0.75)">
                    <div class="btnp">
                      <span href="#">75%</span>
                    </div>
                  </div>
                  <div class="percent" v-on:click="setSell(1)">
                    <div class="btnp">
                      <span href="#">100%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="amount" class="col-xs-12"
                  ><small
                    >{{ $t("Total") }}({{ pair.split("_")[0] }})</small
                  ></label
                >
                <div class="col-xs-12">
                  <input
                    id="amount"
                    v-model="amount"
                    v-on:input="setVolume"
                    class="form-control"
                    type="number"
                    min="0"
                    step="0.00000001"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12 text-right">
                  <i class="fad fa-wallet m-r-xs"></i>
                  <span class="font-bold c-white" v-if="getToken"
                    >{{ fixed(getBalance[pair.split("_")[1]].available) }}
                    {{ pair.split("_")[1] }}</span
                  >
                  <span class="font-bold c-white" v-else
                    >-- {{ pair.split("_")[1] }}</span
                  >
                </div>
              </div>

              <div class="form-group">
                <div class="col-xs-12">
                  <button
                    v-if="loading"
                    class="btn btn-default btn-block"
                    disabled=" "
                  >
                    <i class="fad fa-spinner-third fa-spin m-r-xs"></i
                    >{{ $t("Loading") }}
                  </button>
                  <button
                    v-else-if="!rate || !amount || !volume"
                    class="btn btn-default btn-block"
                    disabled=" "
                  >
                    {{ $t("Sell") }} {{ pair.split("_")[1] }}
                  </button>
                  <button v-else class="btn btn-sell btn-block c-white">
                    {{ $t("Sell") }} {{ pair.split("_")[1] }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-xs-6 orders">
          <!-- ORDER BOOK -->
          <div class="row">
            <div class="col-xs-6">
              <small>{{ $t("Price") }}({{ pair.split("_")[0] }})</small>
            </div>
            <div class="col-xs-6 text-right">
              <small>{{ $t("Total") }}({{ pair.split("_")[1] }})</small>
            </div>
            <div class="col-xs-12" v-if="getDepth.asks">
              <div v-if="asksLength - getDepth.asks.length > 0">
                <div
                  v-for="i in asksLength - getDepth.asks.length"
                  v-bind:key="i"
                >
                  <div class="col-xs-6 text-sell">--</div>
                  <div class="col-xs-6 text-right c-white">--</div>
                </div>
              </div>
              <div
                class="row pointer"
                v-for="b in getDepth.asks.slice(0, asksLength).reverse()"
                v-bind:key="b[0]"
                v-on:click="setPrice(b[0], b[1])"
              >
                <div class="col-xs-6 text-sell">
                  {{ ratedigi(b[0]) }}
                </div>
                <div class="col-xs-6 text-right c-white">
                  {{ volumedigi(b[1]) }}
                  <div
                    class="amount-bar sell-bar"
                    v-bind:style="
                      'width: ' + ((b[1] * b[0]) / 10000) * 185 + '%;'
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <!--  -->

          <!-- last price -->
          <div class="lastprice">
            <img
              class="coin m-r-sm"
              :src="require(`@/assets/tokens/${coin}.png`)"
            />
            <span
              v-if="getTrade.length > 0"
              v-on:click="setPrice(getTrade[0].rate)"
            >
              <span class="text-buy pointer" v-if="getTrade[0].type == 'BUY'">
                {{ ratedigi(getTrade[0].rate)
                }}<i class="m-l-xs fad fa-long-arrow-alt-up"></i
              ></span>
              <span class="text-sell pointer" v-if="getTrade[0].type == 'SELL'">
                {{ ratedigi(getTrade[0].rate)
                }}<i class="m-l-xs fad fa-long-arrow-alt-down"></i
              ></span>
            </span>
            <span v-else>
              <span class="text-muted"
                >N/A <i class="fad fa-long-arrow-alt-right"></i
              ></span>
            </span>

            <span v-if="isConnected" class="pull-right">
              <i class="fad fa-signal text-buy"></i>
            </span>
            <span v-else class="pull-right">
              <i class="fad fa-signal-alt-slash text-mute"></i>
            </span>
          </div>
          <!--  -->

          <!-- bids order -->
          <div class="row">
            <div class="col-xs-12" v-if="getDepth.bids">
              <div
                class="row pointer"
                v-for="b in getDepth.bids.slice(-bidsLength).reverse()"
                v-bind:key="b[0]"
                v-on:click="setPrice(b[0], b[1])"
              >
                <div class="col-xs-6 text-buy">
                  {{ ratedigi(b[0]) }}
                </div>
                <div class="col-xs-6 text-right c-white">
                  {{ volumedigi(b[1]) }}
                  <div
                    class="amount-bar buy-bar"
                    v-bind:style="
                      'width: ' + ((b[1] * b[0]) / 10000) * 185 + '%;'
                    "
                  ></div>
                </div>
              </div>
              <template v-if="bidsLength - getDepth.bids.length > 0">
                <div
                  v-for="i in bidsLength - getDepth.bids.length"
                  v-bind:key="i"
                >
                  <div class="col-xs-6 text-buy">--</div>
                  <div class="col-xs-6 text-right c-white">--</div>
                </div>
              </template>
            </div>
          </div>
          <!--  -->

          <!-- sort button -->
          <div class="row text-center m-t-xs">
            <div
              class="col-xs-4"
              v-on:click="
                bidsLength = 11;
                asksLength = 1;
              "
            >
              <i class="text-buy fad fa-list"></i>
            </div>
            <div
              class="col-xs-4"
              v-on:click="
                bidsLength = 6;
                asksLength = 6;
              "
            >
              <i class="text-accent fad fa-list"></i>
            </div>
            <div
              class="col-xs-4"
              v-on:click="
                asksLength = 11;
                bidsLength = 1;
              "
            >
              <i class="text-sell fad fa-list"></i>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
      <div class="row trade">
        <div class="col-xs-12">
          <div class="row">
            <div class="toporders">
              <div class="topheadorders text-center">
                <div class="col-xs-6 active" v-if="tab == 'MARKETS'">
                  <p class="pointer">{{ $t("MarketTrades") }}</p>
                </div>
                <div class="col-xs-6" v-else v-on:click="tradetab('MARKETS')">
                  <p class="pointer">{{ $t("MarketTrades") }}</p>
                </div>
                <div class="col-xs-6 active" v-if="tab == 'OPENORDERS'">
                  <p class="pointer">{{ $t("OpenOrders") }}</p>
                </div>
                <div
                  class="col-xs-6"
                  v-else
                  v-on:click="tradetab('OPENORDERS')"
                >
                  <p class="pointer">{{ $t("OpenOrders") }}</p>
                </div>
              </div>
            </div>
            <div class="toporders" v-if="tab == 'OPENORDERS'">
              <div class="topheadorders">
                <div
                  class="col-xs-6 active2"
                  v-if="hideotherpair"
                  v-on:click="hide()"
                >
                  <p class="pointer">
                    <i class="m-r-xs fad fa-check-square"></i>
                    {{ $t("HideOtherPairs") }}
                  </p>
                </div>
                <div class="col-xs-6" v-else v-on:click="hide()">
                  <p class="pointer">
                    <i class="m-r-xs fad fa-square"></i>
                    {{ $t("HideOtherPairs") }}
                  </p>
                </div>
                <div class="col-xs-6 text-right">
                  <p
                    class="pointer btnp2"
                    v-on:click="cancelall()"
                    v-if="openorders.length > 0"
                  >
                    {{ $t("CancelAll") }} ({{ openorders.length }})
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="tab == 'MARKETS'">
            <div class="col-xs-4">
              <small>{{ $t("Time") }}</small>
            </div>
            <div class="col-xs-4 text-center">
              <small>{{ $t("Price") }}</small>
            </div>
            <div class="col-xs-4 text-right">
              <small>{{ $t("Amount") }}</small>
            </div>
            <div class="col-xs-12" v-if="getTrade.length > 0">
              <div
                class="row"
                v-for="b in getTrade.slice(0, 30)"
                v-bind:key="b._id"
              >
                <div class="col-xs-4">
                  {{ time(b.timestamps) }}
                </div>
                <div class="col-xs-4 text-center">
                  <span class="text-buy" v-if="b.type == 'BUY'">{{
                    ratedigi(b.rate)
                  }}</span>
                  <span class="text-sell" v-else>{{ ratedigi(b.rate) }}</span>
                </div>
                <div class="col-xs-4 text-right c-white">
                  {{ volumedigi(b.volume) }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="tab == 'OPENORDERS'">
            <div class="loader-example" v-if="!ready">
              <div class="loader-bar"></div>
            </div>
            <div v-else>
              <div v-if="openorders.length > 0">
                <div v-for="b in openorders" v-bind:key="b._id">
                  <div
                    class="openorders"
                    v-if="b.pair == pair || !hideotherpair"
                  >
                    <div class="row">
                      <div class="col-xs-3 text-center">
                        <p>
                          <span v-bind:class="'label ' + b.label">{{
                            b.type
                          }}</span>
                        </p>
                        <span v-if="b.type == 'SELL'">{{
                          filled(b.volume, b.original_volume)
                        }}</span>
                        <span v-if="b.type == 'BUY'">{{
                          filled(b.amount, b.original_amount)
                        }}</span>
                      </div>
                      <div class="col-xs-9">
                        <div class="row">
                          <div class="col-xs-12">
                            <span class="font-bold c-white"
                              >{{ b.pair.split("_")[0] }}/{{
                                b.pair.split("_")[1]
                              }}</span
                            >
                            <small class="pull-right">{{ b.createdAt }}</small>
                          </div>
                          <div class="col-xs-4">
                            {{ $t("Amount") }}<br />
                            {{ $t("Price") }}
                          </div>
                          <div class="col-xs-8" v-if="b.type == 'SELL'">
                            <span class="c-white">{{
                              volumedigi(b.original_volume - b.volume, b.pair)
                            }}</span
                            >/{{ volumedigi(b.original_volume, b.pair) }}<br />
                            {{ ratedigi(b.rate, b.pair) }}
                            <span
                              class="pointer btnp2 pull-right"
                              v-on:click="cancel(b._id)"
                            >
                              {{ $t("Cancel") }}
                            </span>
                          </div>
                          <div class="col-xs-8" v-if="b.type == 'BUY'">
                            <span class="c-white">{{
                              volumedigi(
                                (b.original_amount - b.amount) / b.rate,
                                b.pair
                              )
                            }}</span
                            >/{{ volumedigi(b.original_amount / b.rate, b.pair)
                            }}<br />
                            {{ ratedigi(b.rate, b.pair) }}
                            <span
                              class="pointer btnp2 pull-right"
                              v-on:click="cancel(b._id)"
                            >
                              {{ $t("Cancel") }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="loader-example text-center">
                  <img src="@/assets/nocontent.svg" />
                  <h4 class="text-accent">No open orders</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import func from "@/widgets/func.js";
import exchange from "@/api/exchange.js";
import nativeToast from "native-toast";
import moment from "moment";
import label from "@/widgets/label";

export default {
  data() {
    return {
      pair: this.$route.params.pair || "USDT_BTC",
      ready: false,
      loading: false,
      amount: null,
      volume: null,
      type: "BUY",
      rate: null,
      bidsLength: 6,
      asksLength: 6,
      hideotherpair:
        JSON.parse(localStorage.getItem("HideOtherPairs")) || false,
      openorders: [],
      coin: null,
      tab: localStorage.getItem("TradeTab") || "MARKETS",
    };
  },
  computed: {
    ...mapGetters([
      "getBalance",
      "getPair",
      "getPairing",
      "getToken",
      "getDepth",
      "getTrade",
      "isConnected",
    ]),
  },
  methods: {
    ...mapActions([
      "setSitemode",
      "setPair",
      "fetchDepth",
      "fetchTrade",
      "setTrade",
      "setDepth",
    ]),
    filled(v, o) {
      return ((o - v) / (o / 100)).toFixed(2) + "%";
    },
    hide() {
      this.hideotherpair = !this.hideotherpair;
      localStorage.setItem(
        "HideOtherPairs",
        JSON.stringify(this.hideotherpair)
      );
    },
    desktopmode() {
      this.setSitemode("advanced");
    },
    tradetab(tab) {
      this.tab = tab;
      localStorage.setItem("TradeTab", tab);
    },
    getOrders() {
      this.openorders = [];
      if (this.getToken) {
        exchange
          .openorders()
          .then((res) => {
            this.ready = true;
            res.data.forEach((e) => {
              e.createdAt = moment(e.createdAt).format("YYYY-MM-DD, HH:mm:ss");

              var a = label.type(e.type);
              e.label = a.label;

              this.openorders.push(e);
            });
          })
          .catch((error) => {
            nativeToast({
              message: error.response.data.error,
              position: "top",
              timeout: 1000,
              type: "error",
            });
          });
      } else {
        this.ready = true;
      }
    },
    cancel(order_id) {
      exchange
        .cancel({
          order_id: order_id,
        })
        .then((response) => {
          nativeToast({
            message: response.data.message,
            position: "top",
            timeout: 3000,
            type: "success",
          });
          this.getOrders();
        })
        .catch((error) => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 1000,
            type: "error",
          });
        });
    },
    cancelall() {
      if (confirm("Are you sure you want to cancel all?")) {
        exchange
          .cancelall()
          .then((response) => {
            nativeToast({
              message: response.data.message,
              position: "top",
              timeout: 3000,
              type: "success",
            });
            this.getOrders();
          })
          .catch((error) => {
            nativeToast({
              message: error.response.data.error,
              position: "top",
              timeout: 1000,
              type: "error",
            });
          });
      }
    },
    time(t) {
      return moment(t).format("HH:mm:ss");
    },
    fixed(a) {
      return func.fixed8(a);
    },
    ratedigi(a) {
      if (a) {
        return a.toFixed(this.getPairing[this.pair].rate_digi);
      } else {
        return 0;
      }
    },
    volumedigi(a) {
      if (a) {
        return a.toFixed(this.getPairing[this.pair].volume_digi);
      } else {
        return 0;
      }
    },
    fixedNum(a) {
      return func.fixedNum(a);
    },
    plusPrice() {
      this.rate = (
        this.rate / 1 +
        1 / Math.pow(10, this.getPairing[this.pair].rate_digi)
      ).toFixed(this.getPairing[this.pair].rate_digi);
      this.setAmount();
    },
    minusPrice() {
      if (this.rate > 0) {
        this.rate = (
          this.rate / 1 -
          1 / Math.pow(10, this.getPairing[this.pair].rate_digi)
        ).toFixed(this.getPairing[this.pair].rate_digi);
        this.setAmount();
      }
    },
    plusVolume() {
      this.volume =
        (
          this.volume / 1 +
          this.getPairing[this.pair].secondary_min / 1
        ).toFixed(this.getPairing[this.pair].volume_digi) / 1;
      this.setAmount();
    },
    minusVolume() {
      if (this.volume > 0) {
        this.volume =
          (
            this.volume / 1 -
            this.getPairing[this.pair].secondary_min / 1
          ).toFixed(this.getPairing[this.pair].volume_digi) / 1;
        this.setAmount();
      }
    },
    setPrice(price, volume) {
      if (!volume) volume = this.volume;

      this.rate = this.fixedNum(price);
      this.volume = this.fixedNum(volume);
      this.setAmount();
    },
    setVolume() {
      if (
        this.amount / this.rate >
        1 / Math.pow(10, this.getPairing[this.pair].volume_digi)
      ) {
        this.volume = this.fixedNum(this.amount / this.rate);
      } else {
        this.volume = null;
      }
    },
    setAmount() {
      this.amount = this.fixedNum(this.volume * this.rate);
    },
    setBuy(percent) {
      this.amount = this.fixedNum(
        this.getBalance[this.pair.split("_")[0]].available * percent
      );
      this.volume = this.fixedNum(this.amount / this.rate);
    },
    setSell(percent) {
      this.volume = this.fixedNum(
        this.getBalance[this.pair.split("_")[1]].available * percent
      );
      this.amount = this.fixedNum(this.volume * this.rate);
    },
    async submitBuy() {
      this.loading = true;
      await exchange
        .submit({
          pair: this.pair,
          amount: this.amount,
          type: "BUY",
          rate: this.rate,
        })
        .then((res) => {
          this.loading = false;
          this.amount = null;
          nativeToast({
            message: res.data.message,
            position: "top",
            timeout: 1000,
            type: "success",
          });

          this.getOrders();
        })
        .catch((error) => {
          this.loading = false;
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 1000,
            type: "error",
          });
        });
    },
    async submitSell() {
      this.loading = true;
      await exchange
        .submit({
          pair: this.pair,
          amount: this.volume,
          type: "SELL",
          rate: this.rate,
        })
        .then((res) => {
          this.loading = false;
          this.amount = null;
          nativeToast({
            message: res.data.message,
            position: "top",
            timeout: 1000,
            type: "success",
          });

          this.getOrders();
        })
        .catch((error) => {
          this.loading = false;
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 1000,
            type: "error",
          });
        });
    },
  },
  async created() {
    this.$socket.off("depth." + this.getPair);
    this.$socket.on(
      "depth." + this.pair,
      function (data) {
        this.setDepth(data);
      }.bind(this)
    );

    this.$socket.off("trade." + this.getPair);
    this.$socket.on(
      "trade." + this.pair,
      function (data) {
        this.setTrade(data);
      }.bind(this)
    );

    if (this.pair) {
      this.coin = this.pair.split("_")[1];
      this.fetchDepth(this.pair);
      this.fetchTrade(this.pair).then(() => {
        if (this.getTrade.length > 0) {
          this.rate = this.getTrade[0].rate;
        }
      });
      this.setPair(this.pair);
      this.getOrders();
    }
  },
};
</script>

<style scoped>
.container-center {
  margin-top: 0px;
  padding-top: 0px;
}
.active p {
  color: #f6a821;
  border-bottom-color: #f6a821;
  border-bottom: solid;
  margin: 0 0 5px;
}
.percent {
  position: relative;
  float: left;
  width: 25%;
  padding-left: 3px;
  padding-right: 3px;
  text-align: center;
}
.btnp {
  width: 100%;
  display: inline-block;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-image: none;
  border: 1px solid #949ba2;
  border-radius: 0px;
  color: #949ba2;
}
.btnp:hover {
  border: 1px solid #f6a821;
  color: #f6a821;
}
.orders .col-xs-6 {
  padding-right: 0px;
  padding-left: 10px;
}
.lastprice {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-right: -10px;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #3d404c;
  border-top: 1px solid #3d404c;
}
.text-sell:hover,
.text-buy:hover {
  color: #fff;
}
.trade .col-xs-12 {
  padding-left: 0;
  padding-right: 0;
}
.markettrades {
  padding: 5px 15px;
  font-size: 15px;
  font-weight: bold;
  color: white;
  background-color: #494b54;
}

.amount-bar.sell-bar {
  background: rgba(255, 42, 104, 0.15);
  max-width: 185%;
}
.amount-bar.buy-bar {
  background: rgba(113, 166, 16, 0.15);
  max-width: 185%;
}

.amount-bar {
  position: absolute;
  width: 0;
  bottom: 0;
  right: 0;
  top: 0;
  z-index: -1;
}
.input-group-addon {
  background-color: #52555f;
  border-color: transparent;
}
.form-control {
  text-align: center;
}
.topmarket {
  padding-top: 8px;
  position: static;
  width: 100%;
  height: 33px;
  background-color: #1d1f24;
  z-index: 10;
  margin: 33px auto 0;
}
.tophead .col-xs-3 {
  font-size: 15px;
  padding-left: 3px;
  padding-right: 3px;
  height: 30px;
}
.border-right {
  border-right: 2px solid #949ba2;
  padding-right: 5px;
}
.topheadorders .col-xs-3 {
  font-size: 13px;
  padding-left: 3px;
  padding-right: 3px;
}
.toporders {
  max-width: 1024px;
  padding-top: 5px;
  position: static;
  width: 100%;
  height: 33px;
  background-color: #1d1f24;
  z-index: 10;
  margin: 0 auto 0;
}
.openorders {
  border-bottom: 1px solid #494b54;
  vertical-align: middle;
  padding: 3px 0;
}
.coin {
  width: 22px;
}
.active2 p {
  color: #f6a821;
}
.btnp2 {
  padding: 0px 10px;
  display: inline-block;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-image: none;
  border: 1px solid #f6a821;
  border-radius: 0px;
  color: #f6a821;
}
.btnp2:hover {
  border: 1px solid #f6a821;
  color: #f6a821;
}
</style>
